/** @jsx jsx */
/* eslint-disable no-use-before-define,no-mixed-operators */
import { jsx } from '@emotion/core'
import React from 'react'
import {
    Section,
    getState,
    showModal,
    fmt,
    publish,
    icons,
    getConfig,
    getBrand,
    NO_RESULT_ICON,
    matIcon,
    parseDate,
    iconLabel,
    getOwaTcdaoContext
} from '../twd'
import { useBondDetail } from './use-bond-detail'
import { sectionCss, tableCss } from './style'

const state = getState('bond_detail.best_offerings', {
    show: true
})


const datePrice = (date, price) => [
    date && fmt.mdy(date),
    price && price!=='-' && ('@' + fmt.price3(price))
].filter(Boolean).join('')

export default () => {
    const [showSection, setShowSection_] = React.useState(state.value.show)
    const setShowSection = React.useCallback((m) => {
        state.set({show:m})
        setShowSection_(m)
    }, [])

    const {issue, cusip, bid, ask, offer} = useBondDetail()
    const hasOffer = bid && bid.id  || ask && ask.id
    const hasDiscountYield = ['C','A','T'].indexOf(issue.type)>=0 && issue.category === 'B'


    const brButtons = [
        issue.showBook && <button
            data-name="bond-detail-depth-of-market-button"
            className="link-button"
            style={{minHeight:'20px'}}
            onClick={(e) => {
                showModal({
                    view: 'depth-of-market',
                    cusip: cusip,
                    allowTrading: issue.allowTrading,
                    from: 'bond-detail',
                    source: e.target,
                })
            }}
            >
            {iconLabel(matIcon('layers'), 'Depth of Market')}
        </button>,

        ['A','C','M'].includes(issue.type) && <button
            data-name="bond-detail-trade-history-button"
            className="link-button"
            style={{minHeight:'20px'}}
            onClick={(e) => {
                showModal({
                    view: 'trade-history',
                    cusip: issue.cusip,
                    source: e.target,
                })
            }}
            >
            {iconLabel(matIcon('graphic_eq'), 'Trade History')}
            </button>,
    ].filter(Boolean)

    const isMatured = parseDate(issue.maturityEff) < Date.now()
        || parseDate(issue.redemptionDt) < Date.now()
        || issue.calledInFullInd === 'Y'
    const canTrade = !isMatured
        && issue.allowTrading
        && issue.type!=='P'

    return <React.Fragment>
    <div className="xs-hide vertical-offset-sm"></div>
    <div data-name='bond-detail-best-offering'
        className="container vertical-offset-sm"
        css={sectionCss}>

        <div className="row vertical-offset-sm"></div>
        <div className="row"><div className="col-xs-12">
            <Section
                title="Best offering"
                show={showSection}
                setShow={setShowSection}
                cls="small-header"
                arrowSize="large"
            >
            {!canTrade &&
            <div className="text-body text-center vertical-offset-sm">
                {NO_RESULT_ICON}
                <br/>
                <h4 className="small-header">Security unavailable for online trading</h4>
                For support placing a trade in this security, please call 877-355-3237.
            </div>}


            {canTrade && !hasOffer &&
            <div className="text-body text-center vertical-offset-sm">
                {NO_RESULT_ICON}
                <br/>
                <h4 className="small-header">No current offers</h4>
                You may solicit a quote by submitting a Bid or Offer Wanted request.
            </div>}

            {canTrade && hasOffer &&
            <div>
            <table className="table" css={tableCss}>
            <thead>
                <tr>
                    <th className="col-md-6"></th>
                    <th className="col-md-3 text-right">Bid</th>
                    <th className="col-md-3 text-right">Ask</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td role="rowheader">Quantity</td>
                    <td>{fmt.qty(bid.quantity)}</td>
                    <td>{fmt.qty(ask.quantity)}</td>
                    </tr>
                <tr>
                    <td role="rowheader">Minimum</td>
                    <td>{fmt.qty(bid.quantityMin)}</td>
                    <td>{fmt.qty(ask.quantityMin)}</td>
                </tr>
                <tr>
                    <td role="rowheader">Increment</td>
                    <td>{fmt.qty(bid.quantityIncr)}</td>
                    <td>{fmt.qty(ask.quantityIncr)}</td>
                </tr>
                <tr>
                    <td role="rowheader">Price</td>
                    <td>{fmt.price3N(bid.dispPrice)}</td>
                    <td>{fmt.price3N(ask.dispPrice)}</td>
                </tr>
                <tr>
                    <td role="rowheader">Settlement</td>
                    <td>{fmt.mdy(bid.settlement)}</td>
                    <td>{fmt.mdy(ask.settlement)}</td>
                </tr>
                <tr>
                    <td role="rowheader">Priced to</td>
                    <td>{bid.worstYield || ''}</td>
                    <td>{ask.worstYield || ''}</td>
                </tr>
                { hasDiscountYield && <tr>
                    <td role="rowheader">Discount yield</td>
                    <td>{fmt.ytw3(bid.customerDiscount)}</td>
                    <td>{fmt.ytw3(ask.customerDiscount)}</td>
                </tr> }
                <tr>
                    <td role="rowheader">Yield to worst
                        <br />
                        {datePrice(offer.ytwRdate, offer.ytwRprice)}
                    </td>
                    <td>{fmt.ytw3(bid.ytw, bid.ytwEstInd)}</td>
                    <td>{fmt.ytw3(ask.ytw, ask.ytwEstInd)}</td>
                </tr>
                <tr>
                    <td role="rowheader">Yield to maturity
                        <br />
                        {datePrice(offer.ytmRdate, offer.ytmRprice)}
                    </td>
                    <td>{fmt.ytw3(bid.ytm, bid.ytmEstInd)}</td>
                    <td>{fmt.ytw3(ask.ytm, ask.ytmEstInd)}</td>
                </tr>
                <tr>
                    <td role="rowheader">Yield next call (c)
                        <br/>
                        {datePrice(offer.ytcRdate, offer.ytcRprice)}
                    </td>
                    <td>{fmt.ytw3(bid.ytc)}</td>
                    <td>{fmt.ytw3(ask.ytc)}</td>
                </tr>
                <tr>
                    <td role="rowheader">Yield par call (p)</td>
                    <td>{fmt.ytw3(bid.ytp)}</td>
                    <td>{fmt.ytw3(ask.ytp)}</td>
                </tr>
                <tr>
                    <td role="rowheader">Yield put (u)</td>
                    <td>{fmt.ytw3(bid.ytu)}</td>
                    <td>{fmt.ytw3(ask.ytu)}</td>
                </tr>
                <tr>
                    <td role="rowheader">Yield sink (s)</td>
                    <td>{fmt.ytw3(bid.yts)}</td>
                    <td>{fmt.ytw3(ask.yts)}</td>
                </tr>
                <tr>
                    <td role="rowheader">Current yield</td>
                    <td>{fmt.ytw3(bid.cy)}</td>
                    <td>{fmt.ytw3(ask.cy)}</td>
                </tr>
                <tr>
                    <td role="rowheader">Annual percentage yield</td>
                    <td>{fmt.ytw3(bid.apy)}</td>
                    <td>{fmt.ytw3(ask.apy)}</td>
                </tr>
                <tr>
                    <td role="rowheader">Macaulay duration</td>
                    <td>{fmt.dur(bid.duration)}</td>
                    <td>{fmt.dur(ask.duration)}</td>
                </tr>
                <tr>
                    <td role="rowheader">Mod duration to earliest redemption</td>
                    <td>{fmt.dur(bid.modDurationToCall)}</td>
                    <td>{fmt.dur(ask.modDurationToCall)}</td>
                </tr>
                <tr>
                    <td role="rowheader">Mod duration to worst</td>
                    <td>{fmt.dur(bid.modduration)}</td>
                    <td>{fmt.dur(ask.modduration)}</td>
                </tr>
                <tr>
                    <td role="rowheader">Mod duration to maturity</td>
                    <td>{fmt.dur(bid.modDurationToMaturity)}</td>
                    <td>{fmt.dur(ask.modDurationToMaturity)}</td>
                </tr>
                <tr>
                    <td role="rowheader">Convexity</td>
                    <td>{fmt.cty(bid.convexity)}</td>
                    <td>{fmt.cty(ask.convexity)}</td>
                </tr>
            </tbody>
            </table>
            </div>}

            {(!issue.allowTrading || !hasOffer)
                && <hr className="vertical-offset-sm" aria-hidden="true"/>}

            <div className="col-xs-12 col-md-6 vertical-offset-xs">
                <button
                style={{minHeight:'20px'}}
                data-name="bond-detail-bond-offerings-price-yield-calculator"
                className="link-button"
                onClick={() => {

                    if (getConfig('entitlements.ETradeCalculator', 'No') === 'Yes') {
                        showModal({
                            view: 'calculator',
                            cusip: cusip,
                            action: 'B',
                            from: 'bond-detail',
                            price: ask && ask.price || 100,
                        })                        
                        return
                    }

                    let base = getConfig('bw_service_host') + '/' + getBrand()
                    let sp = new URLSearchParams()
                    sp.set('p_javascript', 2)
                    sp.set('p_data_source', ask && ask.id || bid && bid.id ? 'I' : 'D')
                    sp.set('p_id', ask && ask.id || bid && bid.id || issue.cusip)
                    sp.set('p_price_type', 1)
                    sp.set('p_price', ask && ask.price || bid && bid.price || 100)
                    sp.set('p_quantity', ask && ask.quantity || bid && bid.quantity || 0)
                    sp.set('p_commission', '')
                    sp.set('p_ts', Date.now())

                    let owaTcDaoContext = getOwaTcdaoContext()
                    let url = `${base}/${owaTcDaoContext}/pkg_calc_bond_online.seed?${sp.toString()}`

                    publish('open', {
                        url,
                        name: '_blank',
                        options: "toolbar=no,width=760,height=490,directories=no,status=no,scrollbars=no,resizable=yes,menubar=no"
                    })
                }}
                >
                { iconLabel(icons.calculate, 'Price/yield calculator') }
                </button>
            </div>

            <div className="col-xs-12 col-md-6 vertical-offset-xs">
                {brButtons[0] || null}
            </div>

            <div className="col-xs-12 col-md-6 vertical-offset-xs">
                <button
                style={{minHeight:'20px'}}
                data-name="bond-detail-bond-offerings-tey-calculator"
                className="link-button"
                onClick={(e) => {
                    publish('tey-calculator', {
                        bondType: issue.type,
                        bondYield: ask.ytw || bid.ytw || null,
                        issueState: issue.state,
                        isReset:true,
                        source:e.target,
                    })
                }}
                >
                { iconLabel(icons.calculate, 'TEY calculator') }
                </button>
            </div>
            <div className="col-xs-12 col-md-6 vertical-offset-xs">
                {brButtons[1] || null}
            </div>


            </Section>
        </div></div>

        <div className="row vertical-offset-sm"></div>
    </div>

    </React.Fragment>
}
